import Modal from "@components/ui/modal/modal";
import _ from "lodash";
import dynamic from "next/dynamic";
import { MAX_LG_MODAL_VIEWS, NO_MAX_MODAL_VIEWS } from "./modal-sizes";
import { useModalState } from "./modal.context";
const TagDeleteView = dynamic(() => import("@components/tag/tag-delete-view"));
const TaxDeleteView = dynamic(() => import("@components/tax/tax-delete-view"));
const BanUserView = dynamic(() => import("@components/user/user-ban-view"));
const ShippingDeleteView = dynamic(
  () => import("@components/shipping/shipping-delete-view")
);
const ShippingZoneDeleteView = dynamic(
  () => import("@components/shipping-zone/shipping-zone-delete-view")
);
const CategoryDeleteView = dynamic(
  () => import("@components/category/category-delete-view")
);
const CouponDeleteView = dynamic(
  () => import("@components/coupon/coupon-delete-view")
);
const PromotionDeleteView = dynamic(
  () => import("@components/promotion/promotion-delete-view")
);
const TwoFactorAuthenticationView = dynamic(
  () => import("@components/auth/two-factor-authentication-view")
);

const ProductDeleteView = dynamic(
  () => import("@components/product/product-delete-view")
);
const BannerDeleteView = dynamic(
  () => import("@components/banner/banner-delete-view")
);
const DealDeleteView = dynamic(
  () => import("@components/deal/deal-delete-view")
);
const TypeDeleteView = dynamic(
  () => import("@components/group/group-delete-view")
);
const PaymentGatewayDeleteView = dynamic(
  () => import("@components/payment-gateway/payment-gateway-delete-view")
);
const PaymentMethodDeleteView = dynamic(
  () => import("@components/payment-method/payment-method-delete-view")
);
const AttributeDeleteView = dynamic(
  () => import("@components/attribute/attribute-delete-view")
);
const OrderAttributeDeleteView = dynamic(
  () => import("@components/order-attribute/order-attribute-delete-view")
);
const NotificationTemplateDeleteView = dynamic(
  () => import("@components/notification/notification-template-delete-view")
);
const StaticBlockDeleteView = dynamic(
  () => import("@components/static-block/static-block-delete-view")
);
const StaticBlockPreviewView = dynamic(
  () => import("@components/static-block/static-block-preview-view")
);
const RoleDeleteView = dynamic(
  () => import("@components/role/role-delete-view")
);
const BlockedDomainDeleteView = dynamic(
  () => import("@components/blocklist/blocklist-delete-view")
);

const ApproveShopView = dynamic(
  () => import("@components/shop/approve-shop-view")
);
const DisApproveShopView = dynamic(
  () => import("@components/shop/disapprove-shop-view")
);
const RemoveStaffView = dynamic(
  () => import("@components/shop/staff-delete-view")
);

const BannerMediaCreateView = dynamic(
  () => import("@components/banner/banner-media-create-view")
);
const OrderInvoiceConfirmView = dynamic(
  () => import("@components/order/order-invoice-confirm-view")
);
const OrderCancelConfirmView = dynamic(
  () => import("@components/order/order-cancel-confirm-view")
);
const OrderRefundUpdateConfirmView = dynamic(
  () => import("@components/order/order-refund-update-confirm-view")
);
const CreditMemoRefundConfirmView = dynamic(
  () => import("@components/credit-memo/credit-memo-refund-confirm-view")
);
const DiscountCreateView = dynamic(
  () => import("@components/discount/discount-create-view")
);
const DiscountProductView = dynamic(
  () => import("@components/discount/discount-product-view")
);
const DiscountCategoryView = dynamic(
  () => import("@components/discount/discount-category-view")
);
const DiscountUserView = dynamic(
  () => import("@components/discount/discount-customer-view")
);
const DiscountCustomerGroupView = dynamic(
  () => import("@components/discount/discount-customer-group-view")
);
const CategoryProductView = dynamic(
  () => import("@components/category/category-product-view")
);
const OrderProductView = dynamic(
  () => import("@components/order/order-product-view")
);
const OrderSelectAddress = dynamic(
  () => import("@components/order/order-select-address-view")
);
const ProductInventoryLocationsView = dynamic(
  () => import("@components/product/product-inventory-locations-view")
);
const ProductExportView = dynamic(
  () => import("@components/product/product-export-view")
);
const ProductImportView = dynamic(
  () => import("@components/product/product-import-view")
);
const UserExportView = dynamic(
  () => import("@components/user/user-export-view")
);
const UserImportView = dynamic(
  () => import("@components/user/user-import-view")
);
const UserDeleteView = dynamic(
  () => import("@components/user/user-delete-view")
);
const UserRestoreView = dynamic(
  () => import("@components/user/user-restore-view")
);
const SearchTermExportView = dynamic(
  () => import("@components/search-term/search-term-export-view")
);
const ShipmentProductLocationView = dynamic(
  () => import("@components/shipment/shipment-product-location-view")
);
const DiscountUsageOrdersView = dynamic(
  () => import("@components/discount/discount-usage-orders-view")
);
const DiscardUnsavedFormView = dynamic(
  () => import("@components/common/discard-unsaved-form-prompt-view")
);

const STORE_IMPORT_FORM = dynamic(
  () => import("@components/stores/store-import-form")
);

const STORE_DELETE_VIEW = dynamic(
  () => import("@components/stores/store-delete-view")
);

const NotificationTargetDuplicateModal = dynamic(
  () => import("@components/notification/notification-target-duplicate-modal"),
  { ssr: false }
);

const SCHEDULE_NOTIFICATION_DELETE_VIEW = dynamic(
  () =>
    import(
      "@components/schedule-notifications/schedule-notification-delete-view"
    )
);

const WALLET_RULE_ADD_SKU_VIEW = dynamic(
  () => import("@components/wallet-rule/wallet-rule-add-sku-view")
);
const ManagedModal = () => {
  const { isOpen, view } = useModalState();

  return (
    <Modal
      open={isOpen}
      containerClassName={
        MAX_LG_MODAL_VIEWS.find((val) => val === view)
          ? "max-w-lg"
          : !NO_MAX_MODAL_VIEWS.find((val) => val === view)
          ? "max-w-sm"
          : ""
      }
    >
      {view === "DELETE_PRODUCT" && <ProductDeleteView />}
      {view === "DELETE_BANNER" && <BannerDeleteView />}
      {view === "DELETE_DEAL" && <DealDeleteView />}
      {view === "DELETE_TYPE" && <TypeDeleteView />}
      {view === "DELETE_ATTRIBUTE" && <AttributeDeleteView />}
      {view === "DELETE_CATEGORY" && <CategoryDeleteView />}
      {view === "DELETE_COUPON" && <CouponDeleteView />}
      {view === "DELETE_PROMOTION" && <PromotionDeleteView />}
      {view === "DELETE_TAX" && <TaxDeleteView />}
      {view === "DELETE_SHIPPING" && <ShippingDeleteView />}
      {view === "DELETE_SHIPPING_ZONE" && <ShippingZoneDeleteView />}
      {view === "DELETE_TAG" && <TagDeleteView />}
      {view === "DELETE_PAYMENT_GATEWAY" && <PaymentGatewayDeleteView />}
      {view === "DELETE_PAYMENT_METHOD" && <PaymentMethodDeleteView />}
      {view === "DELETE_ORDER_ATTRIBUTE" && <OrderAttributeDeleteView />}
      {view === "DELETE_NOTIFICATION_TEMPLATE" && (
        <NotificationTemplateDeleteView />
      )}
      {view === "DELETE_STATIC_BLOCK" && <StaticBlockDeleteView />}
      {view === "PREVIEW_STATIC_BLOCK" && <StaticBlockPreviewView />}
      {view === "DELETE_ROLE" && <RoleDeleteView />}
      {view === "DELETE_BLOCKED_DOMAIN" && <BlockedDomainDeleteView />}
      {view === "2FA_AUTHENTICATION_VIEW" && <TwoFactorAuthenticationView />}
      {view === "BAN_USER" && <BanUserView />}
      {view === "SHOP_APPROVE_VIEW" && <ApproveShopView />}
      {view === "SHOP_DISAPPROVE_VIEW" && <DisApproveShopView />}
      {view === "DELETE_STAFF" && <RemoveStaffView />}
      {view === "BANNER_MEDIA_CREATE_VIEW" && <BannerMediaCreateView />}
      {view === "ORDER_INVOICE_VIEW" && <OrderInvoiceConfirmView />}
      {view === "ORDER_CANCEL_VIEW" && <OrderCancelConfirmView />}
      {view === "ORDER_REFUND_UPDATE_VIEW" && <OrderRefundUpdateConfirmView />}
      {view === "CREDIT_MEMO_REFUND_VIEW" && <CreditMemoRefundConfirmView />}
      {view === "DISCOUNT_CREATE_VIEW" && <DiscountCreateView />}
      {view === "DISCOUNT_PRODUCT_VIEW" && <DiscountProductView />}
      {view === "DISCOUNT_CATEGORY_VIEW" && <DiscountCategoryView />}
      {view === "DISCOUNT_USER_VIEW" && <DiscountUserView />}
      {view === "DISCOUNT_CUSTOMER_GROUP_VIEW" && <DiscountCustomerGroupView />}
      {view === "CATEGORY_PRODUCT_VIEW" && <CategoryProductView />}
      {view === "ORDER_PRODUCT_VIEW" && <OrderProductView />}
      {view === "ORDER_SELECT_ADDRESS_VIEW" && <OrderSelectAddress />}
      {view === "PRODUCT_EXPORT_VIEW" && <ProductExportView />}
      {view === "PRODUCT_IMPORT_VIEW" && <ProductImportView />}
      {view === "EDIT_INVENTORY_LOCATIONS_VIEW" && (
        <ProductInventoryLocationsView />
      )}
      {view === "EDIT_SHIPMENT_LOCATION_VIEW" && (
        <ShipmentProductLocationView />
      )}
      {view === "DISCOUNT_USAGE_ORDERS_VIEW" && <DiscountUsageOrdersView />}
      {view === "USER_IMPORT_VIEW" && <UserImportView />}
      {view === "USER_EXPORT_VIEW" && <UserExportView />}
      {view === "SEARCH_TERM_EXPORT_VIEW" && <SearchTermExportView />}
      {view === "DELETE_USER_VIEW" && <UserDeleteView />}
      {view === "RESTORE_USER_VIEW" && <UserRestoreView />}
      {view === "DISCARD_UNSAVED_FORM_VIEW" && <DiscardUnsavedFormView />}
      {view === "STORE_IMPORT_FORM" && <STORE_IMPORT_FORM />}
      {view === "DELETE_STORE" && <STORE_DELETE_VIEW />}
      {view === "NOTIFICATION_TARGET_DUPLICATE_MODAL" && (
        <NotificationTargetDuplicateModal />
      )}
      {view === "DELETE_SCHEDULE_NOTIFICATION" && (
        <SCHEDULE_NOTIFICATION_DELETE_VIEW />
      )}
      {view === "WALLET_RULE_ADD_SKU_VIEW" && <WALLET_RULE_ADD_SKU_VIEW />}
    </Modal>
  );
};

export default ManagedModal;
